import { render, staticRenderFns } from "./AddExtension.vue?vue&type=template&id=cbbb088c&scoped=true&"
import script from "./AddExtension.vue?vue&type=script&lang=js&"
export * from "./AddExtension.vue?vue&type=script&lang=js&"
import style0 from "./AddExtension.vue?vue&type=style&index=0&id=cbbb088c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbb088c",
  null
  
)

export default component.exports